interface UnblockConfirmModalProps {
  data: {
    psychologistId: string;
    fromDate: Date;
    toDate: Date;
    sesionId: string;
    blockageIds?: string[];
  } | null;
  onClose: () => void;
  onConfirm: (psychologistId: string, fromDate: Date, toDate: Date, sesionId: string, blockageIds?: string[]) => void;
}

const UnblockConfirmModal = ({ data, onClose, onConfirm }: UnblockConfirmModalProps) => {
  if (!data) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.4)',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: '1.5rem',
          maxWidth: 380,
          width: '90%',
          boxShadow: '0 8px 30px rgba(0,0,0,0.18)',
          position: 'relative',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '0.75rem',
            right: '0.75rem',
            width: 28,
            height: 28,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'transparent',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            color: '#9ca3af',
            fontSize: '1.1rem',
            lineHeight: 1,
          }}
          aria-label="Cerrar"
        >
          ×
        </button>
        <p style={{ margin: 0, fontSize: '1rem', fontWeight: 700, color: '#1f2937', paddingRight: '2rem' }}>
          Desocupar horario
        </p>
        <p style={{ margin: '0.5rem 0 1.25rem', fontSize: '0.85rem', color: '#6b7280', lineHeight: 1.5 }}>
          {`¿Estás seguro de que querés desocupar el horario del ${data.fromDate.toLocaleDateString('es-AR')} a las ${data.fromDate.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}? Esta acción no se puede deshacer.`}
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
          <button
            type="button"
            onClick={async () => {
              const { psychologistId, fromDate, toDate, sesionId, blockageIds } = data;
              onClose();
              await onConfirm(psychologistId, fromDate, toDate, sesionId, blockageIds);
            }}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: 8,
              border: 'none',
              background: '#ef4444',
              color: '#fff',
              fontSize: '0.85rem',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Eliminar bloqueo
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnblockConfirmModal;
